import React from 'react';
import { css } from 'emotion';
import { connect } from "react-redux";
import { ElementRoot } from '@whalecloud/page-builder-core/components/ElementRoot';
import { Collapse } from '@whalecloud/fdx';
import Element from "@whalecloud/page-builder-core/components/Render/components/Element";
import { getParentElementWithChildren } from "@whalecloud/page-builder-core/components/Render/selectors";

const left = css({ textAlign: 'left' });
const { Panel } = Collapse;
const headerStyle = css({
  '> .ant-collapse-header': {
    borderBottom: '1px solid #e0e0e0'
  }
});

const Card = props => {
  const { element, nameSpace, parentElement, ...restProps } = props;
  const { data, elements } = element;
  const { componentSettings, settings, className = '' } = data;
  const { width, horizontalAlign = 'left', margin: { desktop: { top, bottom, left, right } } } = settings;
  const { bordered: selfBordered = true, backgroundColor, radius } = componentSettings || {};
  const { showArrow = true, bordered, expandIconPosition } = parentElement?.data?.formItemSettings || {};
  const condition = parentElement?.type === 'collapse';
  const headerCondition = selfBordered ? '' : headerStyle;
  let title;

  elements.map(v => {
    if (v.type === 'text') {
      title = v.data.text ? v.data.text : v.data.text.document.nodes[0].nodes[0].leaves[0].text;
    }
  });

  const renderChildren = (elements) => {
    return elements.map(element => {
      return element.type === 'block' && (
        <Element key={element.id} element={element} nameSpace={nameSpace} {...restProps} />
      )
    })
  }

  const panelStyle = condition
  ? {
    background: backgroundColor,
    borderRadius: radius,
    margin: `${top}px ${right}px ${bottom - 1}px ${left}px`
  }
  : {
    background: 'white',
  };

  return (
    <ElementRoot className={'webiny-pb-base-page-element-style'} element={element}>
      {({ getAllClasses, elementStyle }) => (
        <div style={{ textAlign: horizontalAlign }}>
          <Collapse
            style={{ width: width?.value }}
            bordered={condition ? bordered : selfBordered}
            defaultActiveKey={condition ? [] : ['0']}
            className={className}
            expandIconPosition={expandIconPosition}
          >
            <Panel
              header={title}
              disabled={condition ? false : !false}
              showArrow={condition ? showArrow : false}
              style={selfBordered ? panelStyle : { ...panelStyle, border: 0 }}
              className={condition ? '' : headerCondition}
              forceRender={true}
            >
              {renderChildren(elements)}
            </Panel>
          </Collapse>
        </div>
      )}
    </ElementRoot>
  );
};

export default connect<any, any, any>((state, props) => {
  const parentElement = getParentElementWithChildren(state, props.element.id, props.nameSpace)
  return {
    parentElement
  };
}, null)(React.memo(Card));
